import { render } from "./FlashMessages.vue?vue&type=template&id=2d1540b0"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"
script.render = render

export default script